import { firstValueFrom } from 'rxjs';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { HttpService } from 'src/app/services/http.service';

/** proj4 definitions are fetched once per EPSG code for the whole session. */
const projectionRegistry = new Map<string, Promise<void>>();

/**
 * Makes `EPSG:<code>` known to proj4 and OpenLayers (definition from `Sites/proj4/{epsg}`).
 * Concurrent callers share one request; a failed fetch is retried on the next call.
 */
export function ensureProjection(http: HttpService, epsg: string | number): Promise<void> {
  const code = String(epsg);
  let registration = projectionRegistry.get(code);
  if (!registration) {
    registration = firstValueFrom(http.get<string>(`Sites/proj4/${code}`)).then(definition => {
      if (definition) {
        proj4.defs(`EPSG:${code}`, definition);
        register(proj4);
      }
    });
    projectionRegistry.set(code, registration);
    registration.catch(() => projectionRegistry.delete(code));
  }
  return registration;
}
